import { FieldErrors, UseFormWatch } from "react-hook-form";
import { ComponentProps, ComponentType } from "react";
import { FormField } from "./types";
import { Input } from "../common/form/Input/Input";
import { Select } from "../common/form/Select/Select";
import { Textarea } from "../common/form/textarea/Textarea";
import { Radio } from "../common/form/Radio/Radio";
import {
  FormCheckbox,
  FormMultiSelectCheckbox
} from "../common/form/Checkbox/Checkbox";

type FormFieldProps = {
  formField: FormField;
  registerReturnProps: ComponentProps<any>;
  watch?: UseFormWatch<any>;
  errors: FieldErrors;
  disabled?: boolean;
};

export const Field: ComponentType<FormFieldProps> = ({
  formField,
  registerReturnProps,
  watch,
  errors,
  disabled
}) => {
  const { formFieldType, selectOptions, radioOptions, ...rest } = formField;
  const safeFormField = {
    ...rest,
    label: (
      <>
        {formField.label}{" "}
        {formField.required && <span className="text-red-500">*</span>}
      </>
    )
  };
  switch (formFieldType) {
    case "text":
    case "url":
    case "number":
    case "date":
      return (
        <Input
          {...safeFormField}
          {...registerReturnProps}
          type={formFieldType}
          errors={errors}
          disabled={disabled}
        />
      );

    case "select":
      return (
        <Select
          {...safeFormField}
          selectOptions={selectOptions}
          {...registerReturnProps}
          errors={errors}
          disabled={disabled}
        />
      );
    case "textarea":
      return (
        <Textarea
          errors={errors}
          {...safeFormField}
          {...registerReturnProps}
          disabled={disabled}
        />
      );
    case "radio":
      return (
        <Radio
          {...safeFormField}
          radioOptions={radioOptions}
          {...registerReturnProps}
          errors={errors}
          disabled={disabled}
        />
      );

    case "checkbox":
      return (
        <FormCheckbox
          {...safeFormField}
          {...registerReturnProps}
          errors={errors}
          disabled={disabled}
        />
      );
    case "multiSelectCheckbox":
      return (
        <FormMultiSelectCheckbox
          watch={watch}
          {...safeFormField}
          radioOptions={radioOptions}
          {...registerReturnProps}
          errors={errors}
          disabled={disabled}
        />
      );
    default:
      return <></>;
  }
};
